import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux'
import {Bounce, ToastContainer} from 'react-toastify';
import store from './slices'
import 'react-toastify/dist/ReactToastify.css';
import './index.scss';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { logException, installToastErrorLogging } from './services/errorLogger';

// Global error handlers for uncaught exceptions
window.addEventListener('error', (e) => logException(e.error));
window.addEventListener('unhandledrejection', (e) => logException(e.reason));

// Every error toast reaches the error log, regardless of which component raised it.
installToastErrorLogging();

const root = ReactDOM.createRoot(document.getElementById('root'));

const BacApp = (
    <ErrorBoundary>
        <Provider store={store}>
            <App/>
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                newestOnTop={false}
                closeOnClick
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Bounce}
            />
        </Provider>
    </ErrorBoundary>
);

const wrappedApp = process.env.REACT_APP_ENVIRONMENT === 'development' ? (
        <React.StrictMode>{BacApp}</React.StrictMode>
    ) : BacApp;

root.render(wrappedApp);
